// https://github.com/makerbot/sliceconfig/blob/293d1da10701c0067b9568dc172ab78cc64be049/slice_library/machine_config/extruder.json

const extruderMaterialsMap = {
  "mk13": [
    "pla"
  ],

  "mk13_impla": [
    "im-pla"
  ],

  "mk13_experimental": [
    "pla"
  ],

  "mk14": [
    "im-pla",
    "pet",
    "pla"
  ],

  "mk14_s": [
    "pva"
  ],
    
  "mk14_hot": [
    "abs",
    "asa"
  ],
   
  "mk14_hot_s": [
    "sr30",
    "hips"
  ],
   
  "mk14_e": [
    "abs",
    "asa",
    "pet",
    "pla"
  ],
    
  "sketch_extruder": [
    "pla",
    "im-pla"
  ],

  "sketch_l_extruder": [
    "pla",
    "im-pla"
  ],
};

module.exports = extruderMaterialsMap;
